<template>
  <div ref="dressCodeRef" class="dresscode-container">
    <h2 ref="tituloRef" class="titulo">Dress<span class="subtitulo">Code</span></h2><br>
    <p ref="subtituloRef" class="formal">WESTERN FORMAL</p>

    <a ref="btnRef" href="#" class="btn-dress">DRESS INSPO</a>

    <div class="pareja">
      <img ref="parejaRef" src="@/assets/parejas.png" alt="Elegant Couple">
    </div>

    <p ref="p1Ref" class="nota">PLEASE RESERVE THE COLOR WHITE<br>EXCLUSIVELY FOR THE BRIDE</p>
    <hr class="linea-divisoria" />
<br>    <br>

    <p ref="p3Ref" class="nota destacado">  <strong>NO CHILDREN.</strong><br>  <br>We love kids, but this celebration will be for adults only.</p>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'DressCode',
  setup() {
    const dressCodeRef = ref(null)
    const tituloRef = ref(null)
    const subtituloRef = ref(null)
    const btnRef = ref(null)
    const parejaRef = ref(null)
    const p1Ref = ref(null)
    const p2Ref = ref(null)
    const p3Ref = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            gsap.fromTo(tituloRef.value, { opacity: 0, scale: 0.7 }, { opacity: 1, scale: 1, duration: 1.2, ease: 'power3.out' })
            gsap.fromTo(subtituloRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1, delay: 0.3 })
            gsap.fromTo(btnRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1, delay: 0.6 })
            gsap.fromTo(parejaRef.value, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1.3, delay: 0.9, ease: 'back.out(1.7)' })
            gsap.fromTo(p1Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 1.2 })
            gsap.fromTo(p2Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 1.5 })
            gsap.fromTo(p3Ref.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, delay: 1.8 })
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.3 })

      if (dressCodeRef.value) observer.observe(dressCodeRef.value)
    })

    return {
      dressCodeRef,
      tituloRef,
      subtituloRef,
      btnRef,
      parejaRef,
      p1Ref,
      p2Ref,
      p3Ref
    }
  }
}
</script>

<style scoped>
.dresscode-container {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('@/assets/verde.jpg');
  color: #f1e9dc;
   background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  padding: 60px 20px;
  font-family: 'Playfair Display', serif;
  position: relative;
}

.titulo {
  font-size: 30px;
  letter-spacing: 2px;
  margin-bottom: 0;
    font-family: 'subtitulo';

  font-weight: normal;
  line-height: 1.3;
}

.subtitulo {
  font-weight: 500;
  font-size: 36px;
    font-family: 'verde', sans-serif;

}

.formal {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  letter-spacing: 3px;
  margin-top: 15px;
  margin-bottom: 25px;
}

.btn-dress {
  display: inline-block;
  margin-bottom: 30px;
  border: 1px solid #f1e9dc;
  padding: 8px 20px;
  color: #f1e9dc;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
  border-radius: 50px;
  font-size: 13px;
  transition: background 0.3s ease;
}

.btn-dress:hover {
  background-color: #f1e9dc;
  color: #2c2b29;
}

.pareja img {
  width: 140px;
  margin-bottom: 25px;
}

.nota {
  font-size: 11.5px;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 1.2px;
  margin-bottom: 10px;
  color: #f1e9dc;
  font-weight: 300;
}

.destacado {
  font-style: italic;
}
</style>
